__turbopack_context__.v({
  "container": "layout-module__QY5QOq__container",
  "content": "layout-module__QY5QOq__content",
  "fixedScene": "layout-module__QY5QOq__fixedScene",
  "fpsBadge": "layout-module__QY5QOq__fpsBadge",
  "sceneReveal": "layout-module__QY5QOq__sceneReveal",
});
